import './style/index.less';
import MsgConfigSection from './MsgConfigSection';
export default MsgConfigSection;
